
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!courses.syllabus";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'courses/Syllabus';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this, functionType="function";

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <a id=\"toggle_special_dates_in_syllabus\" class=\"shown\" href=\"#\">\n      <span class=\"hide\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "syllabus.hide_specific_dates", "Hide section, group, and person specific dates", options) : helperMissing.call(depth0, "t", "syllabus.hide_specific_dates", "Hide section, group, and person specific dates", options)))
    + "</span>\n      <span class=\"show\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "syllabus.show_specific_dates", "Show section, group, and person specific dates", options) : helperMissing.call(depth0, "t", "syllabus.show_specific_dates", "Show section, group, and person specific dates", options)))
    + "</span>\n    </a>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  
  return "\n    &nbsp;\n  ";
  }

function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    <tr class=\"date";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.passed), {hash:{},inverse:self.noop,fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.date), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n      <td scope=\"row\" valign=\"top\" class=\"day_date\" data-date=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.date), {hash:{},inverse:self.noop,fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.orig_date), {hash:{},inverse:self.noop,fn:self.program(12, program12, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </td>\n      <td class=\"details\">\n        <table class=\"detail_list\">\n          ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.events), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </table>\n      </td>\n    </tr>\n    ";
  return buffer;
  }
function program6(depth0,data) {
  
  
  return " date_passed";
  }

function program8(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += " events_"
    + escapeExpression((helper = helpers.strftime || (depth0 && depth0.strftime),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.date), "%Y_%m_%d", options) : helperMissing.call(depth0, "strftime", (depth0 && depth0.date), "%Y_%m_%d", options)));
  return buffer;
  }

function program10(depth0,data) {
  
  var helper, options;
  return escapeExpression((helper = helpers.strftime || (depth0 && depth0.strftime),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.date), "%Y_%m_%d", options) : helperMissing.call(depth0, "strftime", (depth0 && depth0.date), "%Y_%m_%d", options)));
  }

function program12(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          "
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.orig_date), "medium_with_weekday", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.orig_date), "medium_with_weekday", options)))
    + "\n        ";
  return buffer;
  }

function program14(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <tr class=\"syllabus_";
  if (helper = helpers.type) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.type); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " related-";
  if (helper = helpers.related_id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.related_id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1);
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.override), {hash:{},inverse:self.noop,fn:self.program(15, program15, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" data-workflow-state=\"";
  if (helper = helpers.workflow_state) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.workflow_state); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n            <td class=\"icon\">\n              ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(19, program19, data),fn:self.program(17, program17, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.type), "assignment", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.type), "assignment", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </td>\n            <td class=\"name";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.last), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.html_url), {hash:{},inverse:self.program(31, program31, data),fn:self.program(29, program29, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.override), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </td>\n            <td class=\"dates";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.last), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n              ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.start_at), {hash:{},inverse:self.program(47, program47, data),fn:self.program(35, program35, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </td>\n          </tr>\n          ";
  return buffer;
  }
function program15(depth0,data) {
  
  
  return " special_date";
  }

function program17(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "assignment_976578a8", "Assignment", options) : helperMissing.call(depth0, "t", "assignment_976578a8", "Assignment", options)))
    + "</span>\n                "
    + escapeExpression((helper = helpers.addIcon || (depth0 && depth0.addIcon),options={hash:{},data:data},helper ? helper.call(depth0, "assignment", options) : helperMissing.call(depth0, "addIcon", "assignment", options)))
    + "\n              ";
  return buffer;
  }

function program19(depth0,data) {
  
  var stack1, helper, options;
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(22, program22, data),fn:self.program(20, program20, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.type), "wiki_page", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.type), "wiki_page", options));
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program20(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "page_50c4823d", "Page", options) : helperMissing.call(depth0, "t", "page_50c4823d", "Page", options)))
    + "</span>\n                "
    + escapeExpression((helper = helpers.addIcon || (depth0 && depth0.addIcon),options={hash:{},data:data},helper ? helper.call(depth0, "document", options) : helperMissing.call(depth0, "addIcon", "document", options)))
    + "\n              ";
  return buffer;
  }

function program22(depth0,data) {
  
  var stack1, helper, options;
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(25, program25, data),fn:self.program(23, program23, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.type), "discussion_topic", options) : helperMissing.call(depth0, "ifEqual", (depth0 && depth0.type), "discussion_topic", options));
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program23(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "discussion_topic_dc85ad4c", "Discussion Topic", options) : helperMissing.call(depth0, "t", "discussion_topic_dc85ad4c", "Discussion Topic", options)))
    + "</span>\n                "
    + escapeExpression((helper = helpers.addIcon || (depth0 && depth0.addIcon),options={hash:{},data:data},helper ? helper.call(depth0, "discussion", options) : helperMissing.call(depth0, "addIcon", "discussion", options)))
    + "\n              ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "calendar_event_89aadc1c", "Calendar Event", options) : helperMissing.call(depth0, "t", "calendar_event_89aadc1c", "Calendar Event", options)))
    + "</span>\n                "
    + escapeExpression((helper = helpers.addIcon || (depth0 && depth0.addIcon),options={hash:{},data:data},helper ? helper.call(depth0, "calendar-month", options) : helperMissing.call(depth0, "addIcon", "calendar-month", options)))
    + "\n              ";
  return buffer;
  }

function program27(depth0,data) {
  
  
  return " not_last";
  }

function program29(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                <a href=\"";
  if (helper = helpers.html_url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.html_url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</a>\n              ";
  return buffer;
  }

function program31(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                ";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n              ";
  return buffer;
  }

function program33(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                <div class=\"special_date_title\">("
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.override)),stack1 == null || stack1 === false ? stack1 : stack1.title)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + ")</div>\n              ";
  return buffer;
  }

function program35(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.due_at), {hash:{},inverse:self.program(38, program38, data),fn:self.program(36, program36, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n              ";
  return buffer;
  }
function program36(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "due by", options) : helperMissing.call(depth0, "t", "due by", options)))
    + " <span ";
  stack1 = (helper = helpers.unfudge || (depth0 && depth0.unfudge),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.due_at), options) : helperMissing.call(depth0, "unfudge", (depth0 && depth0.due_at), options));
  buffer += escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, stack1, options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", stack1, options)))
    + " >"
    + escapeExpression((helper = helpers.tTimeHours || (depth0 && depth0.tTimeHours),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.due_at), options) : helperMissing.call(depth0, "tTimeHours", (depth0 && depth0.due_at), options)))
    + "</span>\n                ";
  return buffer;
  }

function program38(depth0,data) {
  
  var stack1;
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.todo_at), {hash:{},inverse:self.program(41, program41, data),fn:self.program(39, program39, data),data:data});
  if(stack1 || stack1 === 0) { return stack1; }
  else { return ''; }
  }
function program39(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "to do:", options) : helperMissing.call(depth0, "t", "to do:", options)))
    + " <span ";
  stack1 = (helper = helpers.unfudge || (depth0 && depth0.unfudge),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.todo_at), options) : helperMissing.call(depth0, "unfudge", (depth0 && depth0.todo_at), options));
  buffer += escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, stack1, options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", stack1, options)))
    + " >"
    + escapeExpression((helper = helpers.tTimeHours || (depth0 && depth0.tTimeHours),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.todo_at), options) : helperMissing.call(depth0, "tTimeHours", (depth0 && depth0.todo_at), options)))
    + "</span>\n                ";
  return buffer;
  }

function program41(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                  <span ";
  stack1 = (helper = helpers.unfudge || (depth0 && depth0.unfudge),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.start_at), options) : helperMissing.call(depth0, "unfudge", (depth0 && depth0.start_at), options));
  buffer += escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, stack1, options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", stack1, options)))
    + " >"
    + escapeExpression((helper = helpers.tTimeHours || (depth0 && depth0.tTimeHours),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.start_at), options) : helperMissing.call(depth0, "tTimeHours", (depth0 && depth0.start_at), options)))
    + "</span>\n                  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.same_time), {hash:{},inverse:self.noop,fn:self.program(42, program42, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ";
  return buffer;
  }
function program42(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n                    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "to", options) : helperMissing.call(depth0, "t", "to", options)))
    + "\n                    <span ";
  stack1 = (helper = helpers.unfudge || (depth0 && depth0.unfudge),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.end_at), options) : helperMissing.call(depth0, "unfudge", (depth0 && depth0.end_at), options));
  buffer += escapeExpression((helper = helpers.contextSensitiveDatetimeTitle || (depth0 && depth0.contextSensitiveDatetimeTitle),options={hash:{},data:data},helper ? helper.call(depth0, stack1, options) : helperMissing.call(depth0, "contextSensitiveDatetimeTitle", stack1, options)))
    + " >\n                      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.same_day), {hash:{},inverse:self.program(45, program45, data),fn:self.program(43, program43, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                   </span>\n                  ";
  return buffer;
  }
function program43(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                        "
    + escapeExpression((helper = helpers.tTimeHours || (depth0 && depth0.tTimeHours),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.end_at), options) : helperMissing.call(depth0, "tTimeHours", (depth0 && depth0.end_at), options)))
    + "\n                      ";
  return buffer;
  }

function program45(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n                        "
    + escapeExpression((helper = helpers.tEventToString || (depth0 && depth0.tEventToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.end_at), "short", "tiny_on_the_hour", options) : helperMissing.call(depth0, "tEventToString", (depth0 && depth0.end_at), "short", "tiny_on_the_hour", options)))
    + "\n                      ";
  return buffer;
  }

function program47(depth0,data) {
  
  
  return "\n                &nbsp;\n              ";
  }

  buffer += "<div id=\"syllabus_links\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.overrides_present), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n<table id=\"syllabus\" class=\"ic-Table ic-Table--condensed\">\n  <thead>\n    <tr>\n      <th scope=\"col\" style=\"width: 25%;\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "headers.date", "Date", options) : helperMissing.call(depth0, "t", "headers.date", "Date", options)))
    + "</th>\n      <th scope=\"col\" style=\"width: 75%;\">\n        <div style=\"float: right;\"></div>\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("courses.syllabus")
  },data:data},helper ? helper.call(depth0, "headers.details", "Details", options) : helperMissing.call(depth0, "t", "headers.details", "Details", options)))
    + "\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.dates), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </tbody>\n</table>\n";
  return buffer;
  });
    ;
    
    import brandableCss from 'compiled/util/brandableCss';
    brandableCss.loadStylesheet('jst/courses/Syllabus', {"new_styles_normal_contrast":{"combinedChecksum":"460196264f"},"new_styles_high_contrast":{"combinedChecksum":"5640ab7af7"},"responsive_layout_normal_contrast":{"combinedChecksum":"f0c4b2295b"},"responsive_layout_high_contrast":{"combinedChecksum":"227cd02662"},"new_styles_normal_contrast_rtl":{"combinedChecksum":"4b4fbcfc5b"},"new_styles_high_contrast_rtl":{"combinedChecksum":"ad0d59c034"},"responsive_layout_normal_contrast_rtl":{"combinedChecksum":"856af72c71"},"responsive_layout_high_contrast_rtl":{"combinedChecksum":"3fe38fe2fe"}}[brandableCss.getCssVariant()]);
  ;
    export default templates[name];
  